import { type HousingSelectionType, mkHousing } from './housingSelectionTypes';

export function transformResponseToHousingSelection(
  response?: { data?: { resources?: HousingSelectionType[] } } | null | undefined,
) {
  if (!response?.data?.resources) {
    return null;
  }
  return response?.data.resources.map((data) =>
    mkHousing({
      id: data.line1 || data.full,
      line1: data.line1,
      line2: data.line2,
      bedrooms: data.bedrooms,
      bathrooms: data.bathrooms,
      areaSquareFeet: data.areaSquareFeet,
      city: data.city,
      state: data.state,
      zipCode: data.zipCode,
      full: data.full,
      assetDetailsList: data.assetDetailsList,
      isDeleted: data.isDeleted,
    }),
  );
}
